module.exports = __webpack_public_path__ + "79bee5a5818c2e7d2889e43232c1b71c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/vectorPHARMACY.jpg
// module id = 1124
// module chunks = 1